import { render, staticRenderFns } from "./pageListGoods.vue?vue&type=template&id=27ab9187&scoped=true&"
import script from "./pageListGoods.vue?vue&type=script&lang=js&"
export * from "./pageListGoods.vue?vue&type=script&lang=js&"
import style0 from "./pageListGoods.vue?vue&type=style&index=0&id=27ab9187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab9187",
  null
  
)

export default component.exports